<template lang="html">

  <div class="finca-view la-bodega">

    <section class="banner-intro brown animation full-view-intro column-center" data="la-bodega">

      <h1 class="title -intro">{{$t('vistas.queseria')}}</h1>

      <h2 class="subtitle-intro">{{$t('vistas.la_finca')}}</h2>

    </section>


    <section class="new-texto-imagen row-center ais animation">

      <div class="textos column-center">
        <h2 class="title">{{$t('la_tierra.queseria.cuadro_uno.titulo')}}</h2>
        <p v-html="$t('la_tierra.queseria.cuadro_uno.texto')"></p>
      </div>
      <div class="contenedor-imagen">
        <img src="/static/img/queseria/maestros-artesanos.png" alt="">
      </div>

    </section>

    
    <section class="new-texto-imagen -inverse row-center ais animation">

      <div class="contenedor-imagen">
        <img src="/static/img/queseria/variedades.png" alt="">
      </div>

      <div class="textos column-center">
        <h2 class="title">{{$t('la_tierra.queseria.cuadro_dos.titulo')}}</h2>
        <div v-html="$t('la_tierra.queseria.cuadro_dos.texto')"></div>
       
      </div>

    </section>

    


    <section class="animation imagen-full-texto row-start" data="queseria" :id="$t(`slider_proceso.proceso_queso.id`)">

      <div class="contenedor-texto column-start">

        <h2 class="title">{{$t('la_tierra.queseria.proceso.titulo')}}</h2>
        <p>{{$t('la_tierra.queseria.proceso.cuerpo')}}</p>
        <router-link :to="$t('enlaces.proceso_queso')" class="btn -proceso">
          <span>{{$t('la_tierra.descubrir_proceso')}}</span> 
        </router-link>

      </div>

      <div class="enlace-proceso">

        <router-link :to="$t('enlaces.proceso_queso')" class="btn-container">

          <span class="btn">
            <span>{{$t('la_tierra.descubrir_proceso')}}</span> 
          </span>

        </router-link>

      </div>

    </section>

    

    <donde-estamos></donde-estamos>

    <otros-lugares></otros-lugares>

        <productos-banner></productos-banner>

    
  </div>

</template>

<script lang="js">


  import otrosLugares from '@/components/parts/otros-lugares';

  import dondeEstamos from '@/components/parts/donde-estamos';

  import productosBanner from '@/components/parts/productos-banner'

  import tourbodega from '@/components/views/experiencias/tour-bodega'

  export default  {
    name: 'la-bodega',
    components : {
      'otros-lugares' : otrosLugares,
      'donde-estamos' : dondeEstamos,
      'productos-banner': productosBanner,
      'tour-bodega' : tourbodega
    }
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .full-view-intro{
    background: url("/static/img/queseria/background-queseria.jpg") center/cover no-repeat;
  }

  .imagen-full-texto[data="queseria"]{
    background: url("/static/img/queseria/elaboracion-queso.jpg") center/cover no-repeat;
  }


  .-tour-bodega .contenedor-imagen{
   background: url('/static/img/foto-tour-bodega.jpg') center no-repeat;
   min-height: 50vw;
   transition: 1s;
 }

 .-movil{
  display: none;
}


@media screen and (max-width: 1200px){
  .imagen-texto{
    padding-bottom: 100px;
    padding-top: 320px;
  }
}

@media screen and (max-width: 1100px){
  .imagen-texto{
    padding-top: 100px;
    padding-bottom: 50px;
    min-height: 0;
    .textos{
      width: 50%;
      padding-left: 20px;
    }
  }
}

@media screen and (max-width: 1023px){
  .imagen-texto{
    padding-top: 240px;
    padding-bottom: 50px;
    min-height: 0;
    .textos{
      width: 100%;
      padding-left: 0px;
    }
  }

  .imagen-full-texto{
    z-index: 4;
  }
}

@media screen and (max-width: 480px){
  .btn.-pc{
    display: none;
  }

  .btn.-movil{
    display: inline-block;
  }

   .-tour-bodega .contenedor-imagen{
   min-height: 100vw;
 }
}

</style>



// WEBPACK FOOTER //
// src/components/views/queseria/queseria.vue